import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import { change } from 'redux-form';
import { Button, ErrorSummary, ShopData, ItemCardList, WhiteButton, PortalInput, CartContainer } from 'components';
import { PortalPageSection, ButtonsSection, PageTitle } from 'components/PortalStructure';
import { InjectedRouter, browserHistory } from 'react-router';
import { showModal, closeModal } from 'modules/modal';
import { IModalAction } from 'models/modal';
import { ICart, ICartAction } from 'models/cart/cart';
import { IItemCardList } from 'models/itemcard';
import { IShoppingBasketItem } from 'models/cart/shoppingbasketitem';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { ICheckoutShopData } from 'models/cart/checkoutshopdata';
import { formatCurrency } from 'helpers/common';
import { IProductQtyUpdateRequest } from 'models/cart/productQtyUpdateRequest';
import { ShoppingBagRemovedItems } from 'components/Cart/ShoppingBagRemovedItems';
import { getProductCard } from 'redux/modules/product/productcard';
import { IProductCardDataAction } from 'models/product/productcard';
import { IUserLanguage } from 'models/user/userlanguage';
import { ILanguage } from 'models/common';
const { connect } = require('react-redux');

require('./style.css');

interface IProps {
	userLanguage?: IUserLanguage;
	languageDomainValues?: ILanguage[];
	cart?: ICart;
	location?: any;
	router: InjectedRouter;
	route: any;

	/* functions props */
	t?: (key: string, options?: any) => string;
	nextPage?: () => void;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	updateShoppingBasketItemQty?: (productQtyUpdateRequest: IProductQtyUpdateRequest) => ICartAction;
	removeShoppingBasketItem?: (itemId: string) => ICartAction;
	change?: (formName: string, field: string, value: any) => void;
	resetShoppingBasketShippingOptions: () => ICartAction;
	getProductCard?: (id: string, target: string) => IProductCardDataAction;
}

interface IShoppingBagItemCardList extends IItemCardList {
	currencyKey?: number;
}

@connect(
	(state: IStore) => ({
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
		cart: state.cart,
	}),
	(dispatch) => ({
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		getShopCard: (shopId: string) => dispatch(getShopCard(shopId)),
		change: (formName: string, field: string, value: any) => dispatch(change(formName, field, value)),
		getProductCard: (id: string, target: string) => dispatch(getProductCard(id, target)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShoppingBag extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.handleOnProductQtyDropdownChange = this.handleOnProductQtyDropdownChange.bind(this);
		this.removeShoppingBasketItem = this.removeShoppingBasketItem.bind(this);
		this.handleCheckoutClick = this.handleCheckoutClick.bind(this);
	}

	public componentDidMount() {
		this.props.resetShoppingBasketShippingOptions();
	}

	public handleCheckoutClick() {
		this.props.nextPage();
	}

	private handleOnProductQtyDropdownChange(productQtyUpdateRequest: IProductQtyUpdateRequest) {
		this.props.updateShoppingBasketItemQty(productQtyUpdateRequest);
	}

	private removeShoppingBasketItem(productId: string) {
		this.props.removeShoppingBasketItem(productId);
	}

	public render() {
		const { t, userLanguage } = this.props;
		const { shoppingBasket } = this.props.cart;

		const culture = userLanguage.culture;
		const homeLink = '/home/' + culture.substring(0, 2);

		const errorSummaryProps = {
			error: this.props.cart ? this.props.cart.error : false,
			message: this.props.cart ? this.props.cart.message : null,
		};

		let itemsContent = null;
		let removedItems: IShoppingBasketItem[] = [];
		if (shoppingBasket && shoppingBasket.items && shoppingBasket.items.length > 0) {
			const items: IShoppingBasketItem[] = shoppingBasket.items;
			removedItems = items.filter((x) => x.shopId === null);
			const shopIds: string[] = shoppingBasket.shopGroupTotals.map((x) => {
				return x.shopId;
			});

			shopIds.sort((a, b) => {
				if (a < b) {
					return -1;
				}
				if (a > b) {
					return 1;
				}

				return 0;
			});

			itemsContent = shopIds.map((shopId) => {
				const shopItems: IShoppingBasketItem[] = items
					.filter((x) => x.shopId === shopId)
					.sort((a, b) => {
						if (a.name < b.name) {
							return -1;
						}
						if (a.name > b.name) {
							return 1;
						}

						return 0;
					});

				if (shopItems && shopItems.length > 0) {
					const listProps: IShoppingBagItemCardList = {
						items: shopItems,
						itemType: c.NODE_TYPE_SHOPPINGBAG_ITEM_CARD,
						customFunction: this.handleOnProductQtyDropdownChange,
						deleteItem: this.removeShoppingBasketItem,
						currencyKey: shoppingBasket.currencyKey,
						goToCard: (id: string, target) => this.props.getProductCard(id, target),
					};

					const firstItem = shopItems[0];

					const shopData: ICheckoutShopData = {
						name: firstItem.shopName,
						location: firstItem.shopLocation,
						picture: firstItem.shopPicture,
					};

					const shopGroupTotal = shoppingBasket.shopGroupTotals.find((x) => x.shopId === shopId);

					return (
						<div className="storeBasketWrapper" key={shopId}>
							<PortalPageSection>
								<ShopData data={shopData} />
							</PortalPageSection>
							<PortalPageSection>
								<ItemCardList {...listProps} />
							</PortalPageSection>
							<PortalPageSection>
								<div className="row">
									<div className="offset-md-5 col-md-5 applyCupon">
										<PortalInput type="text" placeholder={t('Cart_ShoppingBag_Placeholder_HavePromoCode')} />
										<Button type="button">{t('Cart_ShoppingBag_Button_Apply')}</Button>
									</div>
									<div className="col-md-2 subtotal">
										{t('BSPortal_Common_Subtotal')}:{' '}
										{formatCurrency(shoppingBasket.currencyKey, shopGroupTotal.itemsTotal)}
									</div>
								</div>
							</PortalPageSection>
						</div>
					);
				} else {
					return null;
				}
			});
		}

		let totalPriceElement: JSX.Element = null;
		if (shoppingBasket) {
			totalPriceElement = (
				<div>
					{t('BSPortal_Common_Total')}: {formatCurrency(shoppingBasket.currencyKey, shoppingBasket.itemsTotal)}
				</div>
			);
		}

		return (
			<>
				<PageTitle title={t('Cart_ShoppingBag_Label_ShoppingBag')} />
				<CartContainer>
					<div className="shoppingBagForm">
						<div className="profileError">
							<ErrorSummary {...errorSummaryProps} />
						</div>
						<ShoppingBagRemovedItems items={removedItems} removeShoppingBasketItem={this.removeShoppingBasketItem} />
						{itemsContent}
						<ButtonsSection>
							<div className="row">
								<div className="col-sm-6" />
								<div className="col-md-6 buttnSectionPaddingDelete">
									<div className="floatRight">
										<div className="wrapperTotalPrice">{totalPriceElement}</div>
										<WhiteButton
											type="button"
											onClick={() => {
												browserHistory.push(homeLink);
											}}
										>
											{t('Cart_ShoppingBag_Button_ContinueShopping')}
										</WhiteButton>
										<Button type="button" onClick={this.handleCheckoutClick}>
											{t('Cart_ShoppingBag_Button_Checkout')}
										</Button>
										<div className="clear" />
									</div>
									<div className="clear" />
								</div>
							</div>
						</ButtonsSection>
					</div>
				</CartContainer>
			</>
		);
	}
}

export { ShoppingBag };
